<div class="flex bg-col-51 p-a-2">
    @if (product?.data?.image) {
    <div class="m-r-3">
        <div class="w-12 ratio-1-1 overflow-hidden"
             [style.width.px]="60"
             [style.min-width.px]="60">
            <local-shell />
            <img class="rf"
                 [image]="product?.data?.image"
                 [attr.alt]="product?.name">
        </div>
    </div>
    }
    <div class="flex-grow">
        <div class="flex flex-middle p-t-1 p-b-1">
            <p [class]="item() ? 's1' : 'c1'">
                {{product?.name}}
            </p>
            <div class="w-5-s flex flex-middle">
                <p class="no-wrap col-11 m-l-1 c1">+{{currencySymbol}}{{product?.price}}</p>
                <button type="button"
                        class="flex"
                        [iCmsModalOpen]="'protectionPlanInfoModal'"
                        [iCmsModalOpenData]="product">
                    <i class="icon-information inline-flex col-11"
                       aria-hidden="true"
                       [style.font-size.px]="24"></i>
                </button>
            </div>
            @if (item()) {
            <div class="flex-grow"></div>
            <action class="button-inline m-l inline-block va-m"
                    [sizeClass]="'SM: c1, XL: p2'"
                    [status]="removeStatus"
                    (click)="remove()"
                    cy-basketRemove>{{'Remove' | translate}}</action>
            }
        </div>
        <div class="flex flex-justify-between flex-bottom">
            <div class="p-r-2 col-12">
                @if (product?.data?.short_description) {
                <p class="p-b-2"
                   [class]="item() ? `${client.isS || client.isM ? 'c2' : 'c1'}` : 'c2'">
                    {{product?.data?.short_description}}
                </p>
                }
                @if (coveredProducts.length > 0) {
                @for (coveredProduct of coveredProducts; track coveredProduct.id) {
                <p class="block"
                   [class]="item() ? `${client.isS || client.isM ? 'c2' : 'c1'}` : 'c2'">
                    &bull;&nbsp;{{coveredProduct.name}}</p>
                }
                }
            </div>
            @if (!protectionPlansCheckbox() && !item()) {
            <div class="flex flex-justify-end flex-middle">
                <action class="button-1"
                        [status]="status"
                        (click)="submit()"
                        cy-basketAddButton>
                    {{'Add' | translate | uppercase}}
                </action>
                <result class="block"
                        [status]="status"></result>
            </div>
            }
        </div>
        @if (protectionPlansCheckbox()) {
        <ng-container *ngTemplateOutlet="protectionPlansCheckbox()" />
        }
    </div>
</div>